import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { HotelDiscoverForm } from 'app/typings/hotels/Hotel/HotelDiscover';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useSaveHotelDiscover({ hotelId }: { hotelId: number }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: HotelDiscoverForm) =>
      apiMutation(
        'POST',
        {
          path: ENDPOINTS.saveHotelDiscover,
          params: { id: hotelId?.toString() },
        },
        payload
      ) as Promise<HotelDiscoverForm>,
    onSuccess: (response) => {
      message.success('Hotel Discover successfully changed');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotel],
      });

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.hotel, { id: hotelId }],
        response
      );
    },
    onError: () => {
      message.error('Failed to change Hotel Discover.');
    },
  });
}
